import Marquee from "react-fast-marquee";

const words = [
  "BLS-D",
  "AHA",
  "ARES 118",
  "DEFIBRILLAZIONE",
  "PRIMO SOCCORSO",
  "SICUREZZA 81/08",
  "RCP",
];

export const BrandMarquee = () => {
  return (
    <section
      data-testid="brand-marquee"
      className="border-y border-brand-black bg-brand-paper py-6 overflow-hidden select-none"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading font-black uppercase text-6xl md:text-8xl tracking-tighter stroke-text mx-8">
              {w}
            </span>
            <span className="text-brand-red text-4xl mx-2">✚</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
